/* Tartaria theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var T = window.theme || {};
  var S = T.strings || {};
  var R = T.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartJson: '/cart.js' };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function money(cents) {
    try {
      return new Intl.NumberFormat(T.locale || undefined, { style: 'currency', currency: T.currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function imgSize(url, w) {
    if (!url || url.indexOf('data:') === 0) return url || '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ------------------------------------------------------------------ Cart */
  var Cart = {
    get: function () {
      return fetch(R.cartJson, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },
    add: function (items) {
      return fetch(R.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || S.error);
          return j;
        });
      });
    },
    change: function (key, qty) {
      return fetch(R.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    }
  };

  var drawer = $('[data-cart-drawer]');

  function updateCount(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var itemsEl = $('[data-cart-items]', drawer);
    var footEl = $('[data-cart-footer]', drawer);
    var shipEl = $('[data-cart-ship]', drawer);
    updateCount(cart);

    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>' + esc(S.cartEmpty) + '</p><a class="btn btn--gold" href="' + esc(R.root) + 'collections/all">' + esc(S.continueShopping) + '</a></div>';
      footEl.innerHTML = '';
      shipEl.innerHTML = '';
      return;
    }

    var threshold = Math.round((T.freeShipping || 0) * 100);
    if (threshold > 0) {
      var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
      var msg = cart.total_price >= threshold ? S.freeShippingUnlocked : String(S.freeShippingAway || '').replace('{amount}', money(threshold - cart.total_price));
      shipEl.innerHTML = '<p>' + esc(msg) + '</p><span class="ship-bar__track"><span class="ship-bar__fill" style="width:' + pct + '%"></span></span>';
    } else {
      shipEl.innerHTML = '';
    }

    itemsEl.innerHTML = '<ul class="cart-lines">' + cart.items.map(function (item) {
      var meta = '';
      if (item.variant_title && item.product_has_only_default_variant === false) meta += '<p class="cart-line__meta">' + esc(item.variant_title) + '</p>';
      else if (item.variant_title && item.variant_title !== 'Default Title') meta += '<p class="cart-line__meta">' + esc(item.variant_title) + '</p>';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) !== '_' && item.properties[k]) meta += '<p class="cart-line__meta">' + esc(k) + ': ' + esc(item.properties[k]) + '</p>';
        });
      }
      (item.line_level_discount_allocations || []).forEach(function (d) {
        meta += '<p class="cart-line__disc">' + esc(d.discount_application.title) + ' (−' + money(d.amount) + ')</p>';
      });
      var strike = item.original_line_price !== item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
      return '<li class="cart-line" data-line-key="' + esc(item.key) + '">' +
        '<a class="cart-line__img" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(imgSize(item.image, 160)) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="cart-line__info"><a class="cart-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + meta +
        '<button type="button" class="link-btn" data-cart-remove="' + esc(item.key) + '">' + esc(S.remove) + '</button></div>' +
        '<div class="qty"><button type="button" data-cart-qty="' + esc(item.key) + '" data-delta="-1" aria-label="-">−</button>' +
        '<input type="number" value="' + item.quantity + '" min="0" data-cart-input="' + esc(item.key) + '" aria-label="Quantity">' +
        '<button type="button" data-cart-qty="' + esc(item.key) + '" data-delta="1" aria-label="+">+</button></div>' +
        '<div class="cart-line__price">' + strike + '<b>' + money(item.final_line_price) + '</b></div></li>';
    }).join('') + '</ul>';

    var discounts = (cart.cart_level_discount_applications || []).map(function (d) {
      return '<div class="cart-subtotal" style="font-size:14px;font-weight:600"><span>' + esc(d.title) + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>';
    }).join('');
    footEl.innerHTML = discounts +
      '<div class="cart-subtotal"><span>' + esc(S.subtotal) + '</span><span>' + money(cart.total_price) + '</span></div>' +
      '<p class="cart-note-text">' + esc(S.shippingNote) + '</p>' +
      '<a class="btn btn--gold btn--xl btn--block" href="' + esc(R.root) + 'checkout">' + esc(S.checkout) + '</a>';
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  function refreshDrawer(open) {
    return Cart.get().then(function (cart) {
      renderDrawer(cart);
      if (open) openDrawer();
      return cart;
    });
  }

  function afterAdd() {
    if (T.cartType === 'page') { window.location.href = R.cart; return Promise.resolve(); }
    return refreshDrawer(true);
  }

  /* ----------------------------------------------------- Global click events */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest('[data-cart-toggle]')) && T.cartType !== 'page' && drawer) {
      e.preventDefault();
      refreshDrawer(true);
      return;
    }
    if (t.closest('[data-close-cart]')) { closeDrawer(); return; }

    if ((el = t.closest('[data-quick-add]'))) {
      e.preventDefault();
      el.disabled = true;
      var original = el.textContent;
      el.textContent = S.adding;
      Cart.add([{ id: Number(el.getAttribute('data-variant-id')), quantity: 1 }])
        .then(function () { el.textContent = S.added; return afterAdd(); })
        .catch(function (err) { el.textContent = original; alert(err.message || S.error); })
        .then(function () { setTimeout(function () { el.textContent = original; el.disabled = false; }, 1400); });
      return;
    }

    /* Cart quantity / remove (drawer + cart page) */
    var key, input, qty;
    if ((el = t.closest('[data-cart-qty]'))) {
      key = el.getAttribute('data-cart-qty');
      input = el.parentNode.querySelector('[data-cart-input]');
      qty = Math.max(0, (parseInt(input.value, 10) || 0) + Number(el.getAttribute('data-delta')));
      return changeLine(key, qty);
    }
    if ((el = t.closest('[data-cart-remove]'))) {
      return changeLine(el.getAttribute('data-cart-remove'), 0);
    }

    /* Header: menu & search */
    if (t.closest('[data-open-menu]')) { toggleMenu(true); return; }
    if (t.closest('[data-close-menu]')) { toggleMenu(false); return; }
    if (t.closest('[data-open-search]')) { toggleSearch(true); return; }
    if (t.closest('[data-close-search]')) { toggleSearch(false); return; }
  });

  document.addEventListener('change', function (e) {
    var el = e.target.closest && e.target.closest('[data-cart-input]');
    if (el) changeLine(el.getAttribute('data-cart-input'), Math.max(0, parseInt(el.value, 10) || 0));
    var form = e.target.closest && e.target.closest('[data-filter-form]');
    if (form && (e.target.matches('[data-sort]') || e.target.matches('input[type=checkbox]'))) {
      if (e.target.matches('[data-sort]')) form.submit();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); toggleMenu(false); toggleSearch(false); }
  });

  function changeLine(key, qty) {
    return Cart.change(key, qty).then(function (cart) {
      if (drawer && drawer.classList.contains('is-open')) renderDrawer(cart);
      else if (document.body.classList.contains('template-cart')) window.location.reload();
      else renderDrawer(cart);
    });
  }

  function toggleMenu(open) {
    var m = $('[data-mobile-menu]'); if (!m) return;
    m.classList.toggle('is-open', open);
    m.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('no-scroll', open);
  }
  function toggleSearch(open) {
    var s = $('[data-search]'); if (!s) return;
    s.classList.toggle('is-open', open);
    s.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) { var i = $('input[type=search]', s); if (i) setTimeout(function () { i.focus(); }, 50); }
  }

  /* ------------------------------------------------------- Product + bundles */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var P = JSON.parse(jsonEl.textContent);
    var variants = P.variants;
    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v; });
    var current = byId[P.current] || variants[0];
    var threshold = parseInt(root.getAttribute('data-low-stock'), 10) || 0;

    var tiers = $$('[data-tier]', root);
    var optionGroups = $$('.option', root);
    var addBtn = $('[data-add-to-cart]', root);
    var buyBtn = $('[data-buy-now]', root);
    var atcLabel = $('[data-atc-label]', root);
    var errEl = $('[data-buy-error]', root);
    var stockEl = $('[data-stock-alert]', root);
    var hasOptions = optionGroups.length > 0;

    /* ---- gallery */
    var slides = $$('.gallery__slide', root);
    var thumbs = $$('.gallery__thumb', root);
    function showMedia(id) {
      var idx = -1;
      slides.forEach(function (s, i) { if (String(s.getAttribute('data-media-id')) === String(id)) idx = i; });
      if (idx < 0) return;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    }
    function activeIndex() { var i = 0; slides.forEach(function (s, n) { if (s.classList.contains('is-active')) i = n; }); return i; }
    function stepMedia(d) {
      var n = (activeIndex() + d + slides.length) % slides.length;
      showMedia(slides[n].getAttribute('data-media-id'));
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { stepMedia(-1); });
    if (next) next.addEventListener('click', function () { stepMedia(1); });
    var startX = null, main = $('.gallery__main', root);
    if (main) {
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX == null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) stepMedia(dx < 0 ? 1 : -1);
        startX = null;
      });
    }

    /* ---- option pills */
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) if (variants[i].options[j] !== opts[j]) { ok = false; break; }
        if (ok) return variants[i];
      }
      return null;
    }
    optionGroups.forEach(function (group, index) {
      $$('.pill', group).forEach(function (pill) {
        var value = pill.getAttribute('data-value');
        var anyAvail = variants.some(function (v) { return v.options[index] === value && v.available; });
        if (!anyAvail) pill.classList.add('is-soldout');
        pill.addEventListener('click', function () {
          var opts = current.options.slice();
          opts[index] = value;
          var v = findVariant(opts);
          if (!v) {
            v = variants.filter(function (x) { return x.options[index] === value && x.available; })[0] ||
                variants.filter(function (x) { return x.options[index] === value; })[0];
          }
          if (v) setCurrent(v);
        });
      });
    });

    /* ---- unit selects */
    $$('[data-unit]', root).forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (sel.getAttribute('data-index') === '1' && byId[sel.value]) setCurrent(byId[sel.value], true);
        else recalc();
      });
    });

    function activeTier() {
      for (var i = 0; i < tiers.length; i++) if (tiers[i].classList.contains('is-active')) return tiers[i];
      return null;
    }
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        tiers.forEach(function (t) { t.classList.toggle('is-active', t === tier); });
        var radio = $('input[type=radio]', tier); if (radio) radio.checked = true;
        recalc();
      });
      var radio = $('input[type=radio]', tier);
      if (radio) radio.addEventListener('change', function () { tier.click(); });
    });

    function tierUnits(tier) {
      var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      var selects = $$('[data-unit]', tier);
      var list = [];
      for (var i = 0; i < qty; i++) {
        var v = selects[i] ? byId[selects[i].value] : current;
        list.push(v || current);
      }
      return list;
    }

    function recalc() {
      tiers.forEach(function (tier) {
        var off = parseFloat(tier.getAttribute('data-off')) || 0;
        var units = tierUnits(tier);
        var sum = 0, sumCompare = 0;
        units.forEach(function (v) { sum += v.price; sumCompare += Math.max(v.compare, v.price); });
        var total = Math.round(sum * (100 - off) / 100);
        var priceEl = $('[data-tier-price]', tier), compEl = $('[data-tier-compare]', tier), saveEl = $('[data-tier-save]', tier);
        if (priceEl) priceEl.textContent = money(total);
        if (off > 0) {
          if (compEl) { compEl.textContent = money(sum); compEl.hidden = false; }
          if (saveEl) { saveEl.textContent = 'You save ' + money(sum - total); saveEl.hidden = false; }
        } else {
          if (compEl) { if (sumCompare > sum) { compEl.textContent = money(sumCompare); compEl.hidden = false; } else compEl.hidden = true; }
          if (saveEl) saveEl.hidden = true;
        }
      });
      updateButtons();
    }

    function selectedUnits() {
      var tier = activeTier();
      if (!tier) return [current];
      return tierUnits(tier);
    }

    function updateButtons() {
      var units = selectedUnits();
      var ok = units.every(function (v) { return v.available; });
      [addBtn, buyBtn].forEach(function (b) { if (b) b.disabled = !ok; });
      if (atcLabel) atcLabel.textContent = ok ? S.addToCart : S.soldOut;
    }

    function setCurrent(v, fromSelect) {
      current = v;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* noop */ }

      /* price */
      var cur = $('[data-price-current]', root), cmp = $('[data-price-compare]', root), badge = $('[data-price-badge]', root);
      if (cur) cur.textContent = money(v.price);
      if (v.compare > v.price) {
        if (cmp) { cmp.textContent = money(v.compare); cmp.hidden = false; }
        if (badge) { badge.textContent = 'SAVE ' + Math.floor((v.compare - v.price) * 100 / v.compare) + '%'; badge.hidden = false; }
      } else {
        if (cmp) cmp.hidden = true;
        if (badge) badge.hidden = true;
      }

      /* pills */
      optionGroups.forEach(function (group, i) {
        var label = $('[data-option-selected]', group);
        if (label) label.textContent = v.options[i];
        $$('.pill', group).forEach(function (p) {
          var on = p.getAttribute('data-value') === v.options[i];
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });

      /* unit #1 selects follow the pill choice */
      if (!fromSelect) {
        tiers.forEach(function (tier) {
          var first = $('[data-unit][data-index="1"]', tier);
          if (first) first.value = String(v.id);
        });
      }

      /* media */
      if (v.media) showMedia(v.media);

      /* low stock (real inventory only) */
      if (stockEl) {
        if (threshold > 0 && v.tracked && v.deny && v.inventory > 0 && v.inventory <= threshold) {
          $('[data-stock-text]', stockEl).textContent = String(S.lowStock || '').replace('{n}', v.inventory);
          stockEl.hidden = false;
        } else {
          stockEl.hidden = true;
        }
      }
      recalc();
    }

    /* ---- add-ons */
    var addons = $$('[data-addon]', root);
    addons.forEach(function (addon) {
      var toggle = $('[data-addon-toggle]', addon);
      toggle.addEventListener('click', function () {
        toggle.setAttribute('aria-pressed', toggle.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      });
      var sel = $('[data-addon-variant]', addon);
      if (sel) sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        var price = parseInt(opt.getAttribute('data-price'), 10), compare = parseInt(opt.getAttribute('data-compare'), 10) || 0;
        $('[data-addon-price]', addon).textContent = money(price);
        var c = $('[data-addon-compare]', addon);
        if (compare > price) { c.textContent = money(compare); c.hidden = false; } else c.hidden = true;
      });
    });

    function collectItems() {
      var tier = activeTier();
      var units = selectedUnits();
      var counts = {}, order = [];
      units.forEach(function (v) { if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); } counts[v.id]++; });
      var label = tier ? 'Buy ' + tier.getAttribute('data-qty') : '';
      var items = order.map(function (id) {
        var item = { id: id, quantity: counts[id] };
        if (tier && units.length > 1) item.properties = { _Bundle: label };
        return item;
      });
      addons.forEach(function (addon) {
        var toggle = $('[data-addon-toggle]', addon);
        if (toggle.getAttribute('aria-pressed') !== 'true') return;
        var sel = $('[data-addon-variant]', addon);
        items.push({ id: Number(sel ? sel.value : addon.getAttribute('data-variant')), quantity: 1 });
      });
      return items;
    }

    function showError(msg) {
      if (!errEl) return alert(msg);
      errEl.textContent = msg; errEl.hidden = false;
    }

    if (addBtn) addBtn.addEventListener('click', function () {
      if (errEl) errEl.hidden = true;
      addBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = S.adding;
      Cart.add(collectItems())
        .then(function () { if (atcLabel) atcLabel.textContent = S.added; return afterAdd(); })
        .catch(function (err) { showError(err.message || S.error); })
        .then(function () { setTimeout(function () { addBtn.disabled = false; updateButtons(); }, 1200); });
    });

    if (buyBtn) buyBtn.addEventListener('click', function () {
      /* Cart permalink: checks out only these items, without touching the existing cart */
      var parts = collectItems().map(function (i) { return i.id + ':' + i.quantity; });
      window.location.href = R.root + 'cart/' + parts.join(',');
    });

    setCurrent(current);
  }
  $$('[data-product]').forEach(initProduct);

  /* ------------------------------------------- Related products (lazy-loaded) */
  $$('[data-recs]').forEach(function (box) {
    if ($('[data-recs-inner]', box)) return;
    var url = box.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = $('[data-recs-inner]', doc);
      if (inner) box.innerHTML = inner.outerHTML;
    }).catch(function () { /* silent */ });
  });

  /* --------------------------------------------------------- Header polish */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.style.boxShadow = window.scrollY > 10 ? '0 6px 24px rgba(0,0,0,.45)' : 'none'; };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Keep the drawer fresh on load if the cart already has items */
  if (drawer) {
    var count = $('[data-cart-count]');
    if (count && !count.hidden) Cart.get().then(renderDrawer).catch(function () {});
  }
})();
